"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketStatusEmoji = exports.TicketStatus = exports.TicketPriority = void 0;
var TicketPriority;
(function (TicketPriority) {
    TicketPriority["LOW"] = "0";
    TicketPriority["MEDIUM"] = "1";
    TicketPriority["HIGH"] = "2";
    TicketPriority["URGENT"] = "3";
})(TicketPriority = exports.TicketPriority || (exports.TicketPriority = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["OPEN"] = "OPEN";
    TicketStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TicketStatus["RESOLVED"] = "RESOLVED";
    TicketStatus["CLOSED"] = "CLOSED";
})(TicketStatus = exports.TicketStatus || (exports.TicketStatus = {}));
const TicketStatusEmoji = (status) => {
    switch (status) {
        case TicketStatus.OPEN:
            return '🔓';
        case TicketStatus.IN_PROGRESS:
            return '🔧';
        case TicketStatus.RESOLVED:
            return '✅';
        case TicketStatus.CLOSED:
            return '🔒';
    }
};
exports.TicketStatusEmoji = TicketStatusEmoji;
